import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
// import toast from "react-hot-toast";
// import { getUserById } from "../../services/users/userService";

const ModalDetailsSpecialist = ({ open, setOpen, userData, type }) => {
  //   useEffect(() => {
  //     const getInfoUser = async () => {
  //       try {
  //         setLoading(true);
  //         const responseUserData = await getUserById(userId);
  //         setUserData(responseUserData ?? null);
  //         setLoading(false);
  //       } catch (error) {
  //         setOpen(false);
  //         setUserData(null);
  //         setLoading(false);
  //         toast.error("No se pudo obtener la información del usuario.");
  //       }
  //     };
  //     getInfoUser();
  //   }, [userId]);

  //   const formatDate = (date) => {
  //     const dateObj = new Date(date);
  //     const fechaFormateada = dateObj.toLocaleString("es-MX", {
  //       day: "2-digit",
  //       month: "long",
  //       year: "numeric",
  //     });
  //     return fechaFormateada;
  //   };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold">
        Información de {userData?.firstName ?? "Usuario"}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Nombre:</Typography>
              <Typography>
                {userData?.firstName ?? "Sin dato"} {userData?.lastName ?? ""}
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Correo:</Typography>
              <Typography>{userData?.email ?? "Sin dato"} </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Especialidad:</Typography>
              <Typography>
                {userData?.role === "Nutricionist"
                  ? "Nitriólog@"
                  : userData?.role === "Physiotherapy"
                    ? "Fisioterapeuta"
                    : userData?.role === "Coach"
                      ? "Entrenador"
                      : userData?.role === "Psicology"
                        ? "Psicológ@"
                        : "---"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> NickName:</Typography>
              <Typography>{userData?.nickName ?? "---"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Teléfono:</Typography>
              <Typography>{userData?.phoneNumber ?? "---"}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Typography
          sx={{ marginTop: 3, marginBottom: 2 }}
          variant="h6"
          fontWeight="bold"
        >
          Información de la cuenta
        </Typography>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Origen de registro:</Typography>
              <Typography>{userData?.origin ?? "Sin dato"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Membresía:</Typography>
              <Typography>{userData?.membership ?? "Sin dato"}</Typography>
            </Box>
            {/* {userData?.paymentDate && (
              <Box margin={2}>
                <Typography fontWeight="bold"> Último pago:</Typography>
                <Typography>
                  {formatDate(userData?.paymentDate ?? new Date()) ??
                    "Sin dato"}
                </Typography>
              </Box>
            )} */}
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Estatus de la cuenta:</Typography>
              <Typography
                color={
                  userData?.status === "active"
                    ? "green"
                    : userData?.status === "pending"
                      ? "yellow"
                      : "red"
                }
              >
                {userData?.status === "active"
                  ? "Activa"
                  : userData?.status === "pending"
                    ? "Pendiente"
                    : "Inactiva"}
              </Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold">
                Estatus de la Membresía :
              </Typography>
              <Typography
                color={
                  userData?.membershipStatus === "active" ? "green" : "red"
                }
              >
                {userData?.membershipStatus === "active"
                  ? "Activa"
                  : "Inactiva"}
              </Typography>
            </Box>
            {/* {userData?.expiresDateMembership && (
              <Box margin={2}>
                <Typography fontWeight="bold"> Último pago:</Typography>
                <Typography>
                  {formatDate(userData?.expiresDateMembership ?? new Date()) ??
                    "Sin dato"}
                </Typography>
              </Box>
            )} */}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDetailsSpecialist;
